import { render, staticRenderFns } from "./OptimizationIcon.vue?vue&type=template&id=262df35a&scoped=true"
import script from "./OptimizationIcon.vue?vue&type=script&lang=js"
export * from "./OptimizationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262df35a",
  null
  
)

export default component.exports